import type { ClaimInitiativeAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { hasCoin } from "../utils/zone-utils";

export function validateClaimInitiative(
  state: WarchestState,
  action: ClaimInitiativeAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  if (state.initiativeHolder === action.player) {
    return { valid: false, error: "You already have the initiative" };
  }
  if (state.initiativeTransferredThisRound) {
    return { valid: false, error: "Initiative already transferred this round" };
  }
  return { valid: true };
}
